import Main from '@/views/administracion/planeacion/Main.vue';
import Default from '@/views/administracion/planeacion/Default.vue';
import MainObra from '@/views/administracion/planeacion/obra/Main.vue';
import DefaultObra from '@/views/administracion/planeacion/obra/Default.vue';
import MainDocumenosRelacionados from '@/views/administracion/planeacion/obra/documentosrelacionados/Main.vue';
import MainProyectos from '@/views/administracion/control-proyectos/Main.vue';
import MainProyectoTablero from '@/views/administracion/control-proyectos/tablero/Main.vue';
import MainProyectoDocumentos from '@/views/administracion/control-proyectos/documentos/Main.vue';
import MainProyectoValidaciones from '@/views/administracion/control-proyectos/validaciones/Main.vue';
import MainProyectoTareas from '@/views/administracion/control-proyectos/tareas/Main.vue';
import MainProyectoCalendario from '@/views/administracion/control-proyectos/calendario/Main.vue';

import Configuracion from './configuracion';

const auth = ['Planeación:ver'];
const scopes = ['Planeación:crear', 'Planeación:editar', 'Planeación:eliminar'];

const planeacion = [
  {
    path: 'planeacion',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      ...Configuracion,
      {
        name: 'planeacion',
        path: '/',
        meta: {
          title: 'Planeacion',
          auth,
          scopes,
        },
        component: Default,

        children: [],
      },
      {
        path: ':idObra',
        meta: {
          title: 'Obra',
          auth,
          scopes,
        },
        component: MainObra,
        children: [
          {
            name: 'obra',
            path: '/',
            meta: {
              title: 'Obra',
              auth,
              scopes,
            },
            component: DefaultObra,
          },
          {
            name: 'obraDocumentosRelacionados',
            path: 'documentos-relacionados',
            meta: {
              title: 'Documentos Relacionados',
              auth,
              scopes,
            },
            component: MainDocumenosRelacionados,
          },
        ],
      },
      {
        name: 'obraProyectos',
        path: ':idObra/proyecto/:idProyecto',
        meta: {
          title: 'Proyecto',
          auth,
          scopes,
        },
        component: MainProyectos,
        redirect: { name: 'obraProyectoTablero' },
        children: [
          {
            name: 'obraProyectoTablero',
            path: 'tablero',
            meta: {
              title: 'Proyecto Tablero',
              auth,
              scopes,
            },
            component: MainProyectoTablero,
          },
          {
            name: 'obraProyectoDocumentos',
            path: 'documentos',
            meta: {
              title: 'Proyecto Documentos',
              auth,
              scopes,
            },
            component: MainProyectoDocumentos,
          },
          {
            name: 'obraProyectoValidaciones',
            path: 'validaciones',
            meta: {
              title: 'Proyecto Validaciones',
              auth,
              scopes,
            },
            component: MainProyectoValidaciones,
          },
          {
            name: 'obraProyectoTareas',
            path: 'tareas',
            meta: {
              title: 'Proyecto Tareas',
              auth,
              scopes,
            },
            component: MainProyectoTareas,
          },
          {
            name: 'obraProyectoCalendario',
            path: 'calendario',
            meta: {
              title: 'Proyecto Calendario',
              auth,
              scopes,
            },
            component: MainProyectoCalendario,
          },
        ],
      },
    ],
  },
];

export default planeacion;
